import type { SelectOption } from "@/ui2/types";

import type { InsuranceListOptions, InsuranceListResponse } from "../types";
import type { InsuranceCarrier } from "@/core/types";

export function mapCarriersToOptions(data: InsuranceListResponse): InsuranceListOptions {
  const carrierOptions: SelectOption<InsuranceCarrier>[] = data.carriers.map((carrier) => ({
    label: carrier,
    value: carrier,
  }));

  const stateOptions: SelectOption[] = data.state.map((state) => ({
    label: state,
    value: state,
  }));

  return {
    carrierOptions,
    stateOptions,
  };
}
